/** Maternal Health frontend module — shared API helpers + palette. */
import axios from 'axios';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api/maternal`;
const cfg = { withCredentials: true };

export const api = {
  getProfile:    () => axios.get(`${API}/profile`, cfg).then((r) => r.data),
  saveProfile:   (d) => axios.post(`${API}/profile`, d, cfg).then((r) => r.data),
  snapshot:      () => axios.get(`${API}/snapshot`, cfg).then((r) => r.data),
  postCheckin:   (d) => axios.post(`${API}/checkin`, d, cfg).then((r) => r.data),
  recentCheckins:() => axios.get(`${API}/checkins/recent`, cfg).then((r) => r.data),
  trends:        () => axios.get(`${API}/trends`, cfg).then((r) => r.data),
  weekInsight:   () => axios.get(`${API}/week`, cfg).then((r) => r.data),
  appointments:  () => axios.get(`${API}/appointments`, cfg).then((r) => r.data),
  addAppt:       (d) => axios.post(`${API}/appointments`, d, cfg).then((r) => r.data),
  delAppt:       (id) => axios.delete(`${API}/appointments/${id}`, cfg).then((r) => r.data),
  postPP:        (d) => axios.post(`${API}/postpartum`, d, cfg).then((r) => r.data),
  pPRecent:      () => axios.get(`${API}/postpartum/recent`, cfg).then((r) => r.data),
};

export const STATUS_PAL = {
  'On track':        { dot: 'bg-emerald-500', text: 'text-emerald-700', bg: 'bg-emerald-50',  border: 'border-emerald-200' },
  'Needs attention': { dot: 'bg-amber-500',   text: 'text-amber-700',   bg: 'bg-amber-50',    border: 'border-amber-200' },
  'Review needed':   { dot: 'bg-rose-500',    text: 'text-rose-700',    bg: 'bg-rose-50',     border: 'border-rose-200' },
  'Not checked yet': { dot: 'bg-gray-400',    text: 'text-gray-700',    bg: 'bg-gray-50',     border: 'border-gray-200' },
};

export function relTime(iso) {
  if (!iso) return '—';
  const ms = Date.now() - new Date(iso).getTime();
  if (ms < 60_000) return 'just now';
  const m = Math.floor(ms / 60_000);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  if (d < 7) return `${d}d ago`;
  const w = Math.floor(d / 7);
  if (w < 4) return `${w}w ago`;
  return `${Math.floor(d / 30)}mo ago`;
}
